import { makeRequest } from "./api";

export const FetchRoomTypes = async () => {
  return makeRequest("/api/admin/roomtype/fetch");
};

export const CreateRoomType = async (formData) => {
  return makeRequest("/api/admin/roomtype/create", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateRoomType = async (formData) => {
  return makeRequest("/api/admin/roomtype/update", {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeleteRoomType = async (roomTypeId) => {
  return makeRequest(`/api/admin/roomtype/remove/${roomTypeId}`, {
    method: "DELETE",
  });
};
